import React from 'react';
import { UI } from '../ui';

class ShopNav extends React.Component {

    toggleSubmenu(event) {

        if( UI.windowWidth > 960 ) return;

        let li = event.target.parentNode;

        event.preventDefault();

        UI.menu.toggleSubmenu(li);
    }

    renderNavItem(item, key) {
        if(item.subcategories) {
            return (
                <li className="nav__item item--has-submenu" key={key}>
                    <a href={item.url} onClick={ (event) => this.toggleSubmenu(event) }>{item.name}</a>
                    {this.renderSubmenu(item, item.subcategories)}
                </li>
            )
        } else {
            return (
                <li className="nav__item" key={key}>
                    <a href={item.url}>
                        <span className="item__label">{item.name}</span>
                    </a>
                </li>
            )            
        }

    }

    renderSubmenu(item, children) {
        return (
            <ul className="item__submenu">
                <li className="nav__item item--show-all">
                <a href={item.url}>{wp_core.i18n.nav_show_all}</a>
                </li>
                {children.map((item, index) =>
                    this.renderNavItem(item, index)
                )}
            </ul>
        )
    }

    render() {

		return (
			<ul className="nav__item">
			  {this.props.data.map((item, index) =>
                    this.renderNavItem(item, index)
				)}
			</ul>
		);

    }

}

export default ShopNav;